import i18n from "i18next";

export default function getViewOrderLabel(baseLabel, subKey, navItem) {
    let label = baseLabel;

    if (navItem?.label) {
        label = `${label} ${navItem.label}`;
        if (subKey === 'individual') {
            label = `${label} - ${i18n.t('prospect_individual')}`;
        } else if (subKey === 'business') {
            label = `${label} - ${i18n.t('business')}`;
        }
    } else if (subKey === 'individual') {
        label = `${label} ${i18n.t('prospect_individual')}`;
    } else {
        label = `${label} ${i18n.t(subKey)}`;
    }

    return label;
}
